import { Paper, Stack, Typography } from '@mui/material';

type EmptyTableStateProps = {
  hasFilters: boolean;
  emptyStateImage: string;
  emptyStateTitle: string;
  emptyStateMessage: string;
  noResultsImage?: string;
  noResultsTitle?: string;
  noResultsMessage?: string;
};

export function EmptyTableState({
  hasFilters,
  noResultsImage = '/images/no-results.png',
  noResultsTitle = 'No results found',
  noResultsMessage = "We couldn't find what you're looking for",
  emptyStateImage,
  emptyStateTitle,
  emptyStateMessage,
}: EmptyTableStateProps) {
  const image = hasFilters ? noResultsImage : emptyStateImage;
  const title = hasFilters ? noResultsTitle : emptyStateTitle;
  const message = hasFilters ? noResultsMessage : emptyStateMessage;
  const altText = title;

  return (
    <div className="flex flex-col py-12 justify-center h-full rounded-lg items-center align-center bg-light-gray text-mydra-black">
      <Paper elevation={0} className="p-4 max-w-[335px]">
        <img src={image} alt={altText} width={335} height={161} />
        <Stack gap={1} className="mt-4">
          <Typography variant="h4" textAlign="center">
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            {message}
          </Typography>
        </Stack>
      </Paper>
    </div>
  );
}
